var _sodipodi, _style, _g, _rect, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgGroup01Delete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 90",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _sodipodi || (_sodipodi = /*#__PURE__*/React.createElement("sodipodi", {
    id: "namedview2",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch34"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop34"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 123,
    height: 92,
    id: "rect1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 0.49,
    width: 120,
    height: 90,
    id: "rect2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.61 45.49 56.61 38.49 56.61 52.49 66.61 45.49",
    id: "polygon"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.48,31.49a14,14,0,1,1-14,14,14,14,0,0,1,14-14m0-1a15,15,0,1,0,15,15,15,15,0,0,0-15-15Z",
    id: "circle"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#000000",
      stroke: "none",
      strokeWidth: 0.868811,
      strokeOpacity: 1
    },
    id: "opacity",
    cx: 60.48,
    cy: 45.490002,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.907425,
      strokeOpacity: 1
    },
    d: "M 49.845206,37.600502 71.460764,52.788211",
    id: "line"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGroup01Delete);
export default __webpack_public_path__ + "static/media/img_group_01_delete.0d462915db873d29f1660cc8e706b7f7.svg";
export { ForwardRef as ReactComponent };